module.exports = "<div class=\"read-only-text\">\r\n    <p ng-class=\"{'bottom-margin': !vm.removeMargin, 'no-margin': vm.removeMargin, 'disabled': vm.isDisabled }\" ng-if=\"!vm.displayAsNumber\">{{vm.displayedValue}}</p>\r\n    <p ng-class=\"{'bottom-margin': !vm.removeMargin, 'no-margin': vm.removeMargin, 'disabled': vm.isDisabled }\" ng-if=\"vm.displayAsNumber\">{{vm.displayedValue | number:vm.numberOfDecimalPlaces}}</p>\r\n</div>";


/*****************
 ** WEBPACK FOOTER
 ** ./DeliveryCreate/UI/app/core/directives/readOnlyText/templates/readOnlyText.html
 ** module id = 287
 ** module chunks = 0
 **/